module.exports = __webpack_public_path__ + "static/media/Ullmann_GmbH.5cce20a2.jpeg";